import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Hero } from "../sections/Hero";
import { TrustMarquee } from "../sections/TrustMarquee";
import { About } from "../sections/About";
import { Services } from "../sections/Services";
import { FloorFinder } from "../sections/FloorFinder";
import { Team } from "../sections/Team";
import { Awards } from "../sections/Awards";
import { InstagramFeed } from "../sections/InstagramFeed";
import { ContactCTA } from "../sections/ContactCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <TrustMarquee />
        <About />
        <Services />
        <FloorFinder />
        <Team />
        <Awards />
        <InstagramFeed />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
